var SortingOptionsValuesEnum = /* @__PURE__ */ ((SortingOptionsValuesEnum2) => {
  SortingOptionsValuesEnum2["NAME_ASC"] = "name_ASC";
  SortingOptionsValuesEnum2["NAME_DESC"] = "name_DESC";
  SortingOptionsValuesEnum2["PRICE_ASC"] = "price_ASC";
  SortingOptionsValuesEnum2["PRICE_DESC"] = "price_DESC";
  SortingOptionsValuesEnum2["UPDATED_AT_DESC"] = "updated_at_DESC";
  return SortingOptionsValuesEnum2;
})(SortingOptionsValuesEnum || {});
const sortingOptions = [
  {
    label: "Sort: Name A-Z",
    value: "name_ASC" /* NAME_ASC */
  },
  {
    label: "Sort: Name Z-A",
    value: "name_DESC" /* NAME_DESC */
  },
  {
    label: "Sort: Price from low to high",
    value: "price_ASC" /* PRICE_ASC */
  },
  {
    label: "Sort: Price from high to low",
    value: "price_DESC" /* PRICE_DESC */
  },
  {
    label: "Sort: Newest First",
    value: "updated_at_DESC" /* UPDATED_AT_DESC */
  }
];
const defaultSortingOption = "name_ASC";

export {
  SortingOptionsValuesEnum,
  sortingOptions,
  defaultSortingOption
};
